import VForm from '@/vuetify_custom/v-form'
import VModel from '@/vuetify_custom/v-modal_v1'
import AutocompletesAsyncS from '@/vuetify_custom/v-form/components/Autocompletes_Async_v2.js'
import EditAttachments from '@/views/components/file/edit_attachments_v1'
import FileUploader from '@/views/components/file/uploader.vue'
import {postPlacingAdsVasRecordSaveApi} from '../service'
function createParams() {
    return {
        id:null,
        placing_ads_record_id: null,
        service_date:null,
        service_type:null,
        total_price:null,
        contract_type:null,
        contract_id:null,
        bfiles: [],
    }
}


export default {
    data() {
        return {
            dis: false,
            submitLoading: false,
            params:createParams(),
            contract_items: [],
            out_contract_items:[]
        }
    },
    computed: {
        contract_api_hash() {
            return {
                Contract: this.$util.api.contract_select_search,
                OutsourceContract:this.$util.api.outsource_contract_select_search,
            }
        },
        contract_type_c() {
            return this.params.contract_type
        },
        baseInforFields() {
            const d = [(val) => !!val || '必选']
            const arr = [
                {
                    label: '服务时间',
                    type: 'date_picker_v1',
                    key: 'service_date',
                    cols: 12,
                    rules: d,
                    required: true,
                },
               {
                    label: '服务类型',
                    type: 'select_field',
                    key: 'service_type',
                    'item-text': 'label',
                    'item-value': 'value',
                    cols: 12,
                    required: true,
                    items:[
                        {
                            label: '增值',
                            value: 'value_added'
                        },
                        {
                            label: '返点',
                            value: 'rebate'
                        },
                        {
                            label: '追加',
                            value: 'addition'
                        }
                    ],
                    rules: d,
               },
               {
                    label: '金额',
                    type: 'number_field',
                    key: 'total_price',
                    cols: 12,
               },
               {
                    label: '合同类型',
                    type: 'select_field',
                    key: 'contract_type',
                    'item-text': 'label',
                    'item-value': 'value',
                    cols: 12,
                    required: true,
                    items:[
                        {
                            label: '普通合同',
                            value: 'Contract'
                        },
                        {
                            label: '兼职外包合同',
                            value: 'OutsourceContract'
                        },
                    ],
                    rules: d,
                    change:() => {
                      this.items = []
                    }
                },
            ]
            if (this.params.contract_type) {
                const _this = this
                const api = this.contract_api_hash[this.params.contract_type]
                const handle_data_proxy = ((type) => (contracts) => {
                   return _this.contractItemsChange(contracts, type)
                })(this.params.contract_type)
                arr.push({
                    label: '关联合同',
                    key:'contract_id',
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'uid_name',
                   
                    out_params: {
                       //  payment_purpose: _this.params.payment_purpose
                       //   team_id: _this.params.team_id
                    },
                    api,
                    // init_list: [], // this.apply_user_list,
                    cols: 12,
                    required: true,
                    rules: [],
                    items: this.params.contract_type === 'Contract' ? this.contract_items : this.out_contract_items,
                    
                    handle_data:({contracts = []} = {}) => {
                        handle_data_proxy(contracts)
                    },
                    // change: (_, target = {}) => {
                    //  //  _this.changeContract(target)
                    // },
                })
            }
            arr.push({
                show: true,
                cols:8,
                key: 'upload'
            })
            return arr
        },
    },
    methods: {
        edit(p, c) {
            this.dis = true
            this.params = createParams()
            this.params.placing_ads_record_id = p.id
            if (c) {
                this.params.id = c.id
                this.params.service_date = c.service_date
                this.params.service_type = c.service_type
                this.params.total_price = c.total_price
                this.params.contract_type = c.placing_ads_contract && c.placing_ads_contract.contract_type
                const {contract_id, contract_uid, contract_name} = c.placing_ads_contract || {}
                this.params.bfiles = c.bfiles || []
                this.params.contract_id = contract_id
                const current_types = [
                    {
                        id:contract_id,
                        uid: contract_uid,
                        uid_name:`${contract_uid}-${contract_name}`,
                    }
                ]
                if (this.params.contract_type === 'Contract') {
                    this.contract_items = current_types
                } else {
                    this.out_contract_items = current_types
                }
            }
        },
        contractItemsChange(contracts, type) {
            const change_contract_items = type === 'Contract' ? this.contract_items : this.out_contract_items
            const items_hash = change_contract_items.reduce((t, i) => {
                t[i.id] = true
                return t
            }, {})
            contracts = contracts || []
            contracts.forEach(i => {
                if (!items_hash[i.id]) {
                    change_contract_items.push({
                        ...i,
                        uid_name: `${i.uid}-${i.name || i.account}`
                    })
                }
            });
          
        },
        submit() {
            if (!(this.$refs.base && this.$refs.base.validate && this.$refs.base.validate())) {
                return
            }
            this.submitLoading = true
        
            postPlacingAdsVasRecordSaveApi(this.params).then(() => {
                this.$emit('success', this.params)
                this.dis = false
                this.$Message.success('保存成功！')
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        title={this.params.id ? '编辑' : '新增'}
        max-width="600"
        loading={this.submitLoading}
        on={{
             ok: this.submit,
            // cancel: _this.cancel
        }}
       
    >
        <VForm
            ref="base"
            v-model={this.params}
            fields={this.baseInforFields}
            scopedSlots={{
                contract_id:({field}) => {
                        return <AutocompletesAsyncS
                        v-model={this.params}
                        field={field}
                    />
                },
                upload: () => {
                    return <div style="display:flex">
                        <p style="width:40px">
                            附件
                        </p>
                        <div style="flex:1">
                            <EditAttachments
                                files={ this.params.bfiles}
                                modelType="PlacingAdsVasRecord"
                                modelId={this.params.id}
                                />
                                <FileUploader 
                                    validateFile={(file) => {
                                        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                        if (!a) {
                                            this.$vModal.warning({
                                                title:'提示',
                                                content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                            })
                                        }
                                        return a
                                    }}
                                     on={{
                                    uploaded: (bfile) => {
                                        this.params.bfiles.push(bfile)
                                    }
                                }}/>
                                <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                        </div>
                    </div>
                }
            }}
        />
        {/* attitude_rating */}
        </VModel>
    }
}